import { type WorkoutFormat } from "api-client/legacy-trpc";
import { Icon } from "icons";
import { cn } from "ui";

interface SectionFormatIconProps {
  format: WorkoutFormat | null;
  className?: string;
}

export function SectionFormatIcon(props: SectionFormatIconProps) {
  const iconClasses = cn("w-4 h-4", props.className);

  switch (props.format) {
    case "REGULAR":
      return (
        <Icon
          name="tabler-layout-list"
          className={cn(iconClasses, "text-blue-500")}
        />
      );
    case "AMRAP":
      return (
        <Icon
          name="tabler-infinity"
          className={cn(iconClasses, "text-red-500")}
        />
      );
    case "TIMED":
      return (
        <Icon
          name="tabler-stopwatch"
          className={cn(iconClasses, "text-purple-500")}
        />
      );
    case "FREESTYLE":
      return (
        <Icon
          name="tabler-yoga"
          className={cn(iconClasses, "text-green-500")}
        />
      );
    case null:
      return (
        <Icon
          name="tabler-bolt"
          className={cn(iconClasses, "text-amber-500")}
        />
      );
    default:
      return null;
  }
}
